
function Footer() {

return(

    <footer class="main-footer bt-1">
		<div class="pull-right d-none d-sm-inline-block">
				<ul class="nav nav-primary nav-dotted nav-dot-separated justify-content-center justify-content-md-end">
			<li class="nav-item">
			Web Solution By &nbsp;<a href="https://snonfoserv.com" target="_blank"> SN Infoserv</a>
			</li>
		</ul>
		</div>
		&copy; {new Date().getFullYear()} <a href="https://trucoo.in/" target="_blank">Trucoo</a>. All Rights Reserved.
	</footer>
);

}

export default Footer;